import React from "react";
import OldPortfolio from "./oldPortfolio";
import "./style.css";
import OtherProjects from "./otherProjects";

export default function Projects() {
  return (
    <div>
      <OldPortfolio />
      <OtherProjects />
    </div>
  );
}
